<template>
  <div class="operation-detail-container">
    <el-card body-style="overflow-x:auto;" class="old-card">
      <h5>旧数据</h5>
      <json-viewer :value="oldObj" :expand-depth="5" copyable sort expanded></json-viewer>
    </el-card>
    <el-card body-style="overflow-x:auto;" class="new-card">
      <h5>新数据</h5>
      <json-viewer :value="newObj" :expand-depth="5" copyable sort expanded></json-viewer>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'operation-detail',
  props: {
    oldObj: {
      type: Object,
      default: () => { }
    },
    newObj: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.operation-detail-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  .old-card {
    margin-right: 10px;
  }
  .old-card,
  .new-card {
    min-width: 40%;
  }
}
</style>